import ugskInsuredPersonUpload from "application/components/ugsk-upload-insured-person-from-excel/ugskInsuredPersonUpload.component";
import { Product } from "domain/classes/product.class";
import { BoxAccidentToolbarController } from "../boxAccident-toolbar.controller";
import { BoxAccidentJournalController } from "../journal/boxAccidentJournal.controller";
import { BoxAccidentJournalToolbarController } from "../journal/boxAccidentJournalToolbar.controller";
import { AdultAccidentController } from "./adultAccident.controller";
import { AdultAccidentContractDTO } from "./adultAccident.factory";

import ugskBoxAccidentInsurant from "../components/ugsk-box-accident-insurant/ugskBoxAccidentInsurant.component";
import template from "./body.html";

import ugskBoxAccidentContractParams from "../components/ugsk-box-accident-contract-params/ugskBoxAccidentContractParams.component";
import ugskBoxAccidentInsuranceConditions from "../components/ugsk-box-accident-insurance-conditions/ugskBoxAccidentInsuranceConditions.component";
import "../components/ugsk-box-accident-insured-person/ugskBoxAccidentInsuredPerson.component";

import "../journal/journal.resource";

import angular from "angular";
import { ProductsService } from "infrastructure/services/products.service";
import manual from "./manual_adultAccident.pdf";

export class AdultAccident extends Product {
    constructor() {
        super();
        this.code = "adultAccident";
        this.groupName = "Страхование жизни и здоровья";
        this.productName = "Взрослый";
        this.description = "Добровольное страхование от несчастных случаев и болезней";
        this.insuranceRules = {
            base: "https://ugsk.ru/about/pravila/NS.pdf",
        };
        this.insurerCanBeLegalEntity = true;
        this.logo = "nav_personalAccident";
        this.manualUrl = manual;
        this.sort = 120;
        this.template = template;
        this.controller = AdultAccidentController;
        this.toolbarController = BoxAccidentToolbarController;
        this.journalController = BoxAccidentJournalController;
        this.journalToolbarController = BoxAccidentJournalToolbarController;
        this.extraViews = {
            "contractParams@app.adultAccident.index": {
                template: require("./view.contractParams.html"),
            },
            "insuranceConditions@app.adultAccident.index": {
                template: require("./view.insuranceConditions.html"),
            },
            "insurant@app.adultAccident.index": {
                template: require("../view.insurantBase.html"),
            },
            "insuredPerson@app.adultAccident.index": {
                template: require("./view.insuredPerson.html"),
            },
            "payment@app.adultAccident.index": {
                template: require("../view.paymentBase.html"),
            },
        };
    }
    get contractClass() {
        return AdultAccidentContractDTO;
    }
}

angular.module("app.adultAccident", [
    "touchSpin",
    "app.boxAccident.components.insured-person",
    ugskBoxAccidentContractParams,
    ugskBoxAccidentInsuranceConditions,
    ugskInsuredPersonUpload,
    ugskBoxAccidentInsurant,
    "app.boxAccident.journal-resources",
]).run((productsService: ProductsService) => {
    "ngInject";

    productsService.register(new AdultAccident());
});
